<cam-scheduler
  [planningId]="this.planningId()"
  [events]="this.events()"
  [resources]="this.resources()"
  [resourceTimeRanges]="this.timeRanges()"
  [ressourceCard]="this.ressourceCard()"
  [cardComponent]="this.cardComponent()"
  [externalEventSourceFeature]="{
    dragItemSelector: '.bucket-item',
  }"
  (addEventRequest)="this.openCreatePanel($event)"
>
  <ng-content></ng-content>
</cam-scheduler>

<cam-layout-full-panel
  [toggleState]="!!this.isShowPanel()"
  [title]="'plannings.cta.creation'"
  (closeEvent)="this.isShowPanel.set(false)"
  width="70%"
>
  @if (this.isShowPanel()) {
    <div class="d-flex flex-column m-space-md">
      <ng-template
        [ngTemplateOutlet]="this.addEventTemplate()"
        [ngTemplateOutletContext]="{ preset: this.selectedPreset }"
      ></ng-template>
    </div>
  }
</cam-layout-full-panel>
